/** View: the date range of the mail views, in the title bar (2026-10-02,
 *  Waqas: "a single control ... in the area where search and Home are ...
 *  call it View"). One choice for Outlook Folders, Triage, Custom Folders
 *  and AI Classifications (dateRanges.ts). */
import { useState } from "react";
import { CalendarRange, Check, ChevronDown } from "lucide-react";
import { FloatingPopover } from "../../../components/FloatingPopover";
import { DATE_RANGE_OPTIONS, rangeLabel } from "../dateRanges";

export function RangePicker({ value, onChange, compact = false, label }: { value: string; onChange: (v: string) => void; compact?: boolean; label?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative flex-shrink-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        title="Date range for Outlook Folders, Triage, Custom Folders and AI Classifications"
        className={
          "inline-flex items-center gap-1 rounded-lg border border-orange-200 bg-orange-50/80 font-semibold text-orange-800 transition hover:bg-orange-100 active:scale-95 dark:border-orange-800/60 dark:bg-orange-900/30 dark:text-orange-100 dark:hover:bg-orange-900/50 " +
          (compact ? "h-6 px-1.5 text-[11px]" : "h-7 px-2 text-[12px]")
        }
      >
        <CalendarRange className="h-3.5 w-3.5" />
        {label && <span data-range-label="" className="font-normal opacity-75">{label}</span>}
        {rangeLabel(value)}
        <ChevronDown className="h-3 w-3 opacity-60" />
      </button>
      {open && (
        <FloatingPopover onClose={() => setOpen(false)} width={190} align="right">
          <ul role="listbox" aria-label="Date range">
            {DATE_RANGE_OPTIONS.map((o) => (
              <li key={o.value}>
                <button
                  type="button"
                  role="option"
                  aria-selected={o.value === value}
                  onClick={() => {
                    onChange(o.value);
                    setOpen(false);
                  }}
                  className={
                    "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-[13px] transition " +
                    (o.value === value ? "bg-orange-50 font-semibold text-orange-800 dark:bg-orange-900/40 dark:text-orange-100" : "text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-700/60")
                  }
                >
                  <span className="w-3.5">{o.value === value && <Check className="h-3.5 w-3.5" />}</span>
                  {o.label}
                </button>
              </li>
            ))}
          </ul>
          <p className="mt-1 border-t border-slate-100 px-2 pt-1.5 text-[10.5px] leading-snug text-slate-400 dark:border-slate-700">
            For Outlook Folders, Triage, Custom Folders and AI. Lists load more as you scroll.
          </p>
        </FloatingPopover>
      )}
    </span>
  );
}
